import { render, staticRenderFns } from "./SignatureCollection.vue?vue&type=template&id=a0729298&"
import script from "./SignatureCollection.vue?vue&type=script&lang=js&"
export * from "./SignatureCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports